// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"864d6aec","990":"70c08c9e"}[chunkId] + ".chunk.js";
};